var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 101,
    viewBox: "0 0 47 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1828 28.6568L23.2583 13.2901C42.939 39.0508 43.6451 54.0643 20.9221 86.3077L16.1152 83.4752C24.6143 64.7008 28.6267 48.305 1.413 21.8664C1.93317 21.9604 20.178 28.6514 20.178 28.6514L20.1828 28.6568Z",
    fill: "#C6B4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5839 81.5955L46.987 73.4768L12.9588 99.931L9.60951 68.1702L20.5839 81.5955Z",
    fill: "#A678F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 100,
    fill: "white",
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 47 0.834717)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDesktop);
export default __webpack_public_path__ + "static/media/arrow-Desktop.ee53ef2632d8af11d6dd1c3f8656e54f.svg";
export { ForwardRef as ReactComponent };